import { GridEnvironment } from './models';

export const environment: GridEnvironment = {
  environment: 'indexrls',
  csrfToken: 'csrftoken_nonprod',
  production: true,
  test: false,
  appConfig: {
    minIndexEdition: '2017-Q1',
    agGrid: {
      useUnsortIcon: true,
      suppressMenuHide: true,
    },
    locationTables: {
      filterMaxOptions: 500,
    },
    sentryDsn: 'https://a806bba3cd9440ecd5c74f2af2e7804f@o4508211719897088.ingest.de.sentry.io/4508930912616528',
  },
  paths: {
    img: '/assets/img',
    icons: '/assets/img/icons',
  },
  googleTagManagerId: 'GTM-WKT7W45',
  salesforceDeepDiveCampaignId: '701UB00000WtrAvYAJ',
  changePasswordUrl: null,
  blankMapTileUrl: 'https://tiles.staging.maplecroft.com/map-resources/tiles/rasters-2012.blank_raster/{z}/{x}/{y}.png',
  mapsBackendBaseURL: 'https://maps.indexrls.maplecroft.com/maps', // Assumes CloudFront.
  mapsOpenStreetMapVectorTilesetName: 'grid-analyse_v0.2.15',
  industry: {
    api: '/industry-risk/api/v1/',
    frontendApi: '/industry-risk/fe-api/v1/',
  },
  commodity: {
    api: '/commodity-api/',
  },
  signInSecurityPdfType: 'download-asset',
  oktaPasswordPolicyID: '00p9nfpk3pNa0x4Mg2p7',
};
